module.exports = __webpack_public_path__ + "img/hero-section-login.837648d5.png";